// General
import { configureStore } from '@reduxjs/toolkit';
// Storages
import toastReducer from './slices/ToastSlice';
import authReducer from './slices/AuthSlice';
import printReducer from './slices/PrintSlice';
import DownloadReducer from './slices/DownloadSlice';
import locationReducer from '../data/general/LocationSlice'


export const store = configureStore({
  reducer: {
    toast: toastReducer,
    auth: authReducer,
    print: printReducer,
    location: locationReducer,
    download: DownloadReducer,
    

  },
})